// fields to compare between the assistance_request and person (contact) records
export const COMPARISON_FIELDS = [
  'title',
  'suffix',
  'gross_monthly_income',
  'race',
  'gender',
  'ethnicity',
  'citizenship',
  'marital_status',
];

// keys from assistance_request.person_military which directly map to defaultEnums.contact_data.military
export const MILITARY_ENUM_FIELDS = [
  'current_status',
  'branch',
  'service_era',
  'deployed',
  'discharge_type',
  'proof_of_veteran_status',
  'proof_type',
];

// keys from assistance_request.person_military which do not map to defaultEnums.contact_data.military
export const MILITARY_DATE_FIELDS = [
  'entry_date',
  'exit_date',
  'deployment_starts_at',
  'deployment_ends_at',
];

// keys from assistance_request.person_military which indirectly map to defaultEnums.contact_data.military
export const MILITARY_ENUM_MAPPINGS = {
  currently_transitioning: 'transitioning',
  at_least_one_day_active_duty: 'active_duty',
  discharged_due_to_disability: 'discharge_disability',
  service_connected_disability: 'connected_disability',
  service_connected_disability_rating: 'disability_rating',
};
